export const STALE_TIME = 10000;
export const RETRY = false;
export const WINDOW_FOCUS_REFETCH = false;
